"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _featureTogglesContext = require("./featureTogglesContext");
Object.keys(_featureTogglesContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _featureTogglesContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _featureTogglesContext[key];
    }
  });
});
